import * as React from 'react';
import AddCategoryBtn from './AddCategoryBtn';
import { useGetAllExpanceQuery } from '@/store/expancesApi';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import ExpenseFormDialog from '../ExpenseFormDialog';
import useSearchExpanse from '@/hooks/useSearchExpanse';
import RecentTransactions from './RecentTransactions';
import FeaturedSections from './FeaturedSections';
import { useParams } from 'react-router-dom';
import { useGetExpenseCategoryQuery } from '@/store/ExpenseCategoryApi';
import ExpanseFilterSection from './ExpanseFilterSection';

const ExpensePage = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const { data: allExpanses } = useGetAllExpanceQuery(user?.token);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredExpenses, setFilteredExpenses] = React.useState<
    Expense[] | string
  >('');
  const [isOpen, setIsOpen] = React.useState(false);
  const [editData, setEditData] = React.useState<Expense | null>(null);
  const { data: allLedger } = useGetExpenseCategoryQuery(user?.token);

  // Fetch category (ledger.ledger) from the URL params
  const { category } = useParams(); // category is the ledger name (like 'salary')

  // Filter expenses based on the 'ledger.ledger' field
  const filteredByLedgerName = allExpanses?.filter(
    (expense) => expense.ledger.ledger === category
  );

  // Use the search hook with the filtered expenses
  const { filterBySearchTerm } = useSearchExpanse(
    filteredByLedgerName,
    searchTerm,
    filteredExpenses
  );

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
          <h1 className="text-2xl font-bold text-foreground mb-4 sm:mb-0">
            Expense Management
          </h1>

          <div className="border-2 border-green-600 px-3 py-1 rounded-md bg-green-50">
            <h1 className="text-md font-bold text-green-600 mb-4 sm:mb-0">
              {category.toUpperCase()}
            </h1>
          </div>

          <div className="flex flex-wrap gap-3">
            <AddCategoryBtn />
            <ExpenseFormDialog
              open={isOpen}
              setOpen={setIsOpen}
              editExpense={editData}
              setEdit={setEditData}
            />
          </div>
        </div>

        {/* Filter Section */}
        <ExpanseFilterSection
          filterBySearchTerm={filterBySearchTerm}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>

      {/* Render filtered transactions based on the selected ledger (ledger.ledger) */}
      <RecentTransactions
        filterBySearchTerm={filterBySearchTerm} // Pass filtered expenses with search term
        setEditData={setEditData}
        setIsOpen={setIsOpen}
      />

      <FeaturedSections />
    </div>
  );
};

export default ExpensePage;
